import { makeVar } from '@apollo/client';

export const headerImageCached = makeVar([]);
export const subMenuItem = makeVar('');